import './src/utilities/reactDomFindDomNodePolyfill';
import('./main');
import('@fsa/app-info');
